import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Avatar } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { SELLER } from '../../../propTypes';
import UserName from './UserName';
import { DEFAULT_AVATAR_SIZE } from './constants';
import './style.scss';

const CardSellerProfile = ({
    username,
    thumbnail,
    size = DEFAULT_AVATAR_SIZE,
    withSellerLink = false,
    onSellerLinkClick = noop,
    variationsCounter = 0,
    refCtxId = '',
    contextReferrer = '',
}) => (
    <div className="card-seller-profile">
        <Avatar className="seller-avatar" src={thumbnail} username={username} size={size} />
        <div className="username-and-variations">
            <div className="username">
                <span>
                    <I18n k="variations_display.by" />{' '}
                </span>
                <UserName
                    withSellerLink={withSellerLink}
                    username={username}
                    onSellerLinkClick={onSellerLinkClick}
                    refCtxId={refCtxId}
                    contextReferrer={contextReferrer}
                />
            </div>
            {variationsCounter > 0 && (
                <div className="variations">
                    {variationsCounter} <I18n k="variations_display.variations" />
                </div>
            )}
        </div>
    </div>
);

CardSellerProfile.propTypes = {
    ...SELLER,
    size: PropTypes.number,
    withSellerLink: PropTypes.bool,
    onSellerLinkClick: PropTypes.func,
    variationsCounter: PropTypes.number,
    refCtxId: PropTypes.string,
    contextReferrer: PropTypes.string,
};

export default CardSellerProfile;
